import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { Wind, ReceiptText, BadgeCheck } from "lucide-react";
import Accreditations from "@/components/Accreditations";
import Savings from "@/components/Savings";
import RebateStack from "@/components/RebateStack";
import WhyC2HPanel from "@/components/WhyC2HPanel";
import BrightePayPanel from "@/components/BrightePayPanel";
import RealResults from "@/components/RealResults";
import Installations from "@/components/Installations";
import WhereInstalled from "@/components/WhereInstalled";
import RinnaiRange from "@/components/RinnaiRange";
import Explainer from "@/components/Explainer";
import HowItWorks from "@/components/HowItWorks";
import Faq from "@/components/Faq";
import ClosingCta from "@/components/ClosingCta";
import StickyMobileBar from "@/components/StickyMobileBar";
import Footer from "@/components/Footer";

export const scrollToForm = () => {
  const el = document.getElementById("quote-form");
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const HERO_BENEFITS = [
  { icon: Wind, text: "Heats water from the air" },
  { icon: ReceiptText, text: "Rebates handled for you" },
  { icon: BadgeCheck, text: "Licensed and insured plumbers" },
];

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
    <div className="min-h-screen bg-cream" data-testid="c2h-landing-page">
      <Header />
      <main>
        <Hero />
        <section
          data-testid="panels-section"
          className="bg-navy pb-16 md:pb-24"
        >
          <div
            data-testid="hero-benefits"
            className="max-w-[1200px] mx-auto px-4 md:px-8 pt-8 pb-10 md:pt-10 md:pb-12 flex flex-wrap justify-center gap-x-10 gap-y-3"
          >
            {HERO_BENEFITS.map((b) => (
              <p
                key={b.text}
                className="flex items-center gap-2 text-sm md:text-base text-white"
              >
                <b.icon className="w-5 h-5 text-glight shrink-0" />
                {b.text}
              </p>
            ))}
          </div>
          <div className="max-w-[1200px] mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-12 items-start">
            <WhyC2HPanel />
            <BrightePayPanel />
          </div>
        </section>
        <Savings />
        <Accreditations />
        <RebateStack />
        <RealResults />
        <Installations />
        <WhereInstalled />
        <RinnaiRange />
        <Explainer />
        <HowItWorks />
        <Faq />
        <ClosingCta />
      </main>
      <StickyMobileBar />
      <Footer />
    </div>
    </MotionConfig>
  );
}

export default App;
